export default "__VITE_ASSET__Qq9D2_Fu__"